"use client"
import { useEffect, type RefObject } from "react"
import { useMetricDetails } from "./metricDetailsContext"

// While a metric-details state is open, a pointerdown anywhere outside the
// HUD column closes it — clicking back into the article dismisses the panel
// the way clicking away dismisses a menu (Escape already does the same in
// MetricDetailsHudState). Two guards:
//   - anything inside the HUD container stays live (the panel itself, the
//     graph, the back chip);
//   - anything inside a [role="dialog"] stays live — the MOBILE details card
//     is a fixed overlay OUTSIDE the HUD container, so without this guard
//     every tap inside it would read as "outside" and dismiss it.
// Capture phase, so an inner stopPropagation can't swallow the dismiss.
export const useDetailsClickAway = (containerRef: RefObject<HTMLElement | null>) => {
  const { openId, close } = useMetricDetails()
  useEffect(() => {
    if (!openId) return
    const onPointerDown = (e: PointerEvent) => {
      const target = e.target
      if (!(target instanceof Node)) return
      if (containerRef.current?.contains(target)) return
      if (target instanceof Element && target.closest('[role="dialog"]')) return
      close()
    }
    document.addEventListener("pointerdown", onPointerDown, { capture: true })
    return () => document.removeEventListener("pointerdown", onPointerDown, { capture: true })
  }, [openId, close, containerRef])
}
